import React, { h, Component } from 'preact';;
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import MONameBorderWidget from './MONameBorderWidget';
import MenuObjectBar from './MenuObjectBar';
import MenuObject from '../canvas/menu-object';
import Renderer from '../canvas/renderer';
import util from '../util';

export default @connect(reduce, actions)
class AsideMONameBorder extends Component {
    constructor() {
        super()
        
        this.openColorPicker = (type) => {
            util.openColorPicker(type, false);
        }
    }

    render(props, state) {
        return (
            <div className={'aside-mo-name-border'}>
                <div className={'scroller'}>
                    <MONameBorderWidget
                        $element={this.props.$element}
                        moNameBackgroundOpacity={this.props.moNameBackgroundOpacity}
                        moNameBackgroundColor={this.props.moNameBackgroundColor}
                        moNameLineWidth={this.props.moNameLineWidth}
                        moNameLineColor={this.props.moNameLineColor}
                        moNameBorderWidth={this.props.moNameBorderWidth}
                        moNameBorderColor={this.props.moNameBorderColor}
                        moNameBackgroundRadius={this.props.moNameBackgroundRadius}
                        openColorPicker={this.openColorPicker.bind(this)}
                        isFromAside={true}
                    />
                </div>
            </div>
        )
    }
}
